export var LINKS_MENU_EXTENSION_TYPE = 'com.atlassian.confluence.links-menu';
export var LINKS_MENU_EXTENSION_ANALYTIC_SOURCE = 'linksMenuExtension';